import React from 'react'
import RightSidebarGlobal from '../../Components/RightSidebarGlobal'
import TabContentOrganizational from '../../Components/TabContentOrganizational'

function OrganizationalStructure() {
  return (
    <>
    <div class="wrapper">
    <div class="inner_page_Sec">
    <div class="col-sm-12 float-left left_sec searchPageTop">
<p>BENFED, being a Cooperative Society is governed by its Management i.e. the Board of Directors or by the Special Officer in absence of a Board. 
  The Managing Director is the highest designated officer of BENFED and presently Hon’ble Additional Chief Secretary to the Government of West 
  Bengal Cooperation Department is acting as the <strong><i>Managing Director of BENFED</i></strong>.
BENFED has its Head Office at Southend Conclave (3rd Floor), 1582, Rajdanga Main Road, Kasba, Kolkata-700107 beside its branches.</p>
      <TabContentOrganizational />

    <p style={{marginTop:20}}>BENFED Head Office works under two divisions’ viz. Administrative division and Business division. The Administrative division is 
      headed by the General Manager (Administration) and the Business division is headed by the General Manager (Business). 
      Accounts section under the supervision of Chief Audit & Accounts Officer (CA&AO) deliberates all accounting activity of BENFED.</p>

    </div>
    {/* <div class="col-sm-4 float-left">
    <RightSidebarGlobal/>
    </div> */}

    </div>
    </div>

    </>
  )
}

export default OrganizationalStructure